// removed by extract-text-webpack-plugin
module.exports = {"textExpandButton":"textExpandButton__1MSYZ","textShrinkButton":"textShrinkButton__MJ6Z5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpandableList/index.css
// module id = 1490
// module chunks = 0